import moment from 'moment/moment'
import request from '@/utils/request'

const list = () => {
  const params = { productType: 'shaanxiRadar', date: moment().format('YYYYMMDD'), }
  return request.get('/wdt_qiniu_rest/product', params).then((data: any) => {
      if (!data || data.length === 0) return
      return data
  }).catch((err: any) => {
      console.log(err)
    return []
  })




  // const iqueryParam =  'RAD.GetDataListByTypeCodeAndTimes|1|String;MDBZ_RADDATA2_P|' +
  //   'DateTime;' + moment().subtract(6, 'hours').format('YYYY-MM-DD HH:mm:ss') +
  //   '|DateTime;' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
  //   '|Int32;20|Int32;-1'
  // const params = {
  //   calltype: 4,
  //   iquery: iqueryParam,
  // }
  // return request.get('/Weather/RAD.aspx', params).then((data: any) => {
  //   if (!data || !data.Rows || data.Rows.length === 0) {
  //     return []
  //   }
  //   return data.Rows.reverse()
  // })
}
export default { list }
